import { useState } from "react";
import axios from "axios";

const gold = "#c8a96e";
const EMPTY = { name: "", cost: "", renewal_cost: "", registrar: "", purchase_date: "", expiry: "", asking_price: "", platforms: "", status: "محتفظ", notes: "" };

function getDaysLeft(expiry) {
  if (!expiry) return null;
  return Math.ceil((new Date(expiry) - new Date()) / 86400000);
}

function RenewalLog({ domain, onRefresh }) {
  const [open, setOpen] = useState(false);
  const [date, setDate] = useState("");
  const [cost, setCost] = useState("");
  const [loading, setLoading] = useState(false);

  async function add() {
    if (!date) return;
    setLoading(true);
    await axios.post(`/api/domains/${domain.id}/renewals`, { date, cost: parseFloat(cost) || 0 });
    setDate(""); setCost(""); setLoading(false); onRefresh();
  }

  async function remove(rid) {
    await axios.delete(`/api/domains/${domain.id}/renewals/${rid}`);
    onRefresh();
  }

  const renewals = domain.renewals || [];

  return (
    <div style={{ marginTop: 10 }}>
      <button onClick={() => setOpen(!open)}
        style={{ background: "rgba(124,156,186,0.1)", border: "1px solid rgba(124,156,186,0.2)", borderRadius: 7, padding: "6px 14px", color: "#7c9cba", cursor: "pointer", fontSize: 12 }}>
        🔄 سجل التجديدات ({renewals.length})
      </button>
      {open && (
        <div style={{ background: "rgba(255,255,255,0.03)", borderRadius: 10, padding: 14, marginTop: 10, border: "1px solid rgba(255,255,255,0.07)" }}>
          <div style={{ color: "#7c9cba", fontSize: 12, marginBottom: 10, fontWeight: 700 }}>سجل التجديدات</div>
          {renewals.length === 0 && <div style={{ color: "#555", fontSize: 12, marginBottom: 10 }}>لا توجد تجديدات</div>}
          {renewals.map((r) => (
            <div key={r.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "7px 0", borderBottom: "1px solid rgba(255,255,255,0.05)", fontSize: 12 }}>
              <span style={{ color: "#aaa" }}>{r.date}</span>
              <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                <span style={{ color: "#7c9cba" }}>${r.cost}</span>
                <button onClick={() => remove(r.id)} style={{ background: "none", border: "none", color: "#444", cursor: "pointer", fontSize: 14 }}>✕</button>
              </div>
            </div>
          ))}
          <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
            <input type="date" value={date} onChange={(e) => setDate(e.target.value)}
              style={{ flex: 2, background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 7, padding: "8px", color: "#fff", fontSize: 12, outline: "none" }} />
            <input type="number" placeholder="$" value={cost} onChange={(e) => setCost(e.target.value)}
              style={{ flex: 1, background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 7, padding: "8px", color: "#fff", fontSize: 12, outline: "none" }} />
            <button onClick={add} disabled={loading}
              style={{ background: "#7c9cba", color: "#0f0d0a", border: "none", borderRadius: 7, padding: "8px 14px", fontWeight: 700, cursor: "pointer" }}>+</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default function Portfolio({ domains, onRefresh }) {
  const [form, setForm] = useState(EMPTY);
  const [adding, setAdding] = useState(false);
  const [expanded, setExpanded] = useState(null);
  const [aiResult, setAiResult] = useState({});
  const [aiLoading, setAiLoading] = useState(null);
  const [saving, setSaving] = useState(false);

  const inp = { width: "100%", boxSizing: "border-box", background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 8, padding: "10px 12px", color: "#fff", fontSize: 13, outline: "none", marginBottom: 10, fontFamily: "inherit" };
  const lbl = { color: "#777", fontSize: 11, marginBottom: 4, display: "block" };

  async function add() {
    if (!form.name) return;
    setSaving(true);
    await axios.post("/api/domains", { ...form, cost: parseFloat(form.cost) || 0, renewal_cost: parseFloat(form.renewal_cost) || 0, asking_price: parseFloat(form.asking_price) || 0 });
    setForm(EMPTY); setAdding(false); setSaving(false); onRefresh();
  }

  async function remove(id) {
    if (!window.confirm("حذف هذا الدومين نهائياً؟")) return;
    await axios.delete(`/api/domains/${id}`);
    onRefresh();
  }

  async function analyze(d) {
    setAiLoading(d.id);
    const res = await fetch("https://api.anthropic.com/v1/messages", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ model: "claude-sonnet-4-20250514", max_tokens: 1000,
        system: "أنت خبير في استثمار الدومينات، تتحدث العربية وتقدم تحليلات مختصرة ومفيدة.",
        messages: [{ role: "user", content: `حلل الدومين "${d.name}" باختصار (3-4 أسطر): نوعه، نقطة قوته، وتقدير سعر البيع.` }] })
    }).then(r => r.json()).then(d => d.content?.[0]?.text || "");
    setAiResult(p => ({ ...p, [d.id]: res }));
    setAiLoading(null);
  }

  const sc = { "محتفظ": "#7c9cba", "معروض": "#8bc4a8", "مباع": "#c8a96e" };
  const totalInvested = domains.reduce((s, d) => s + (d.cost || 0) + (d.renewals || []).reduce((rs, r) => rs + r.cost, 0), 0);

  return (
    <div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10, marginBottom: 20 }}>
        {[["إجمالي", domains.length, gold], ["مستثمر", `$${totalInvested.toFixed(0)}`, "#7c9cba"], ["معروض", domains.filter(d => d.status === "معروض").length, "#8bc4a8"]].map(([l, v, c]) => (
          <div key={l} style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.07)", borderRadius: 10, padding: "12px 8px", textAlign: "center" }}>
            <div style={{ color: c, fontWeight: 700, fontSize: 18 }}>{v}</div>
            <div style={{ color: "#555", fontSize: 11, marginTop: 3 }}>{l}</div>
          </div>
        ))}
      </div>

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
        <span style={{ color: "#666", fontSize: 13 }}>{domains.length} دومين</span>
        <button onClick={() => setAdding(!adding)}
          style={{ background: gold, color: "#0f0d0a", border: "none", borderRadius: 8, padding: "9px 18px", fontWeight: 700, cursor: "pointer", fontSize: 13 }}>
          {adding ? "إلغاء" : "+ إضافة"}
        </button>
      </div>

      {adding && (
        <div style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(200,169,110,0.25)", borderRadius: 16, padding: 20, marginBottom: 20 }}>
          <div style={{ color: gold, fontWeight: 700, fontSize: 13, marginBottom: 16 }}>◈ بيانات الدومين</div>

          <label style={lbl}>اسم الدومين *</label>
          <input placeholder="example.com" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} style={{ ...inp, direction: "ltr" }} />

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
            <div><label style={lbl}>سعر الشراء ($)</label>
              <input type="number" placeholder="10" value={form.cost} onChange={(e) => setForm({ ...form, cost: e.target.value })} style={{ ...inp, direction: "ltr" }} /></div>
            <div><label style={lbl}>تكلفة التجديد ($)</label>
              <input type="number" placeholder="10" value={form.renewal_cost} onChange={(e) => setForm({ ...form, renewal_cost: e.target.value })} style={{ ...inp, direction: "ltr" }} /></div>
          </div>

          <label style={lbl}>المسجّل (Registrar)</label>
          <input placeholder="Namecheap / GoDaddy" value={form.registrar} onChange={(e) => setForm({ ...form, registrar: e.target.value })} style={{ ...inp, direction: "ltr" }} />

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
            <div><label style={lbl}>📅 تاريخ الشراء</label>
              <input type="date" value={form.purchase_date} onChange={(e) => setForm({ ...form, purchase_date: e.target.value })} style={{ ...inp, direction: "ltr" }} /></div>
            <div><label style={lbl}>⏰ تاريخ الانتهاء</label>
              <input type="date" value={form.expiry} onChange={(e) => setForm({ ...form, expiry: e.target.value })} style={{ ...inp, direction: "ltr", borderColor: "rgba(196,124,124,0.4)" }} /></div>
          </div>

          <label style={lbl}>سعر البيع المطلوب ($)</label>
          <input type="number" placeholder="500" value={form.asking_price} onChange={(e) => setForm({ ...form, asking_price: e.target.value })} style={{ ...inp, direction: "ltr" }} />

          <label style={lbl}>منصات البيع</label>
          <input placeholder="Sedo, Afternic, Dan..." value={form.platforms} onChange={(e) => setForm({ ...form, platforms: e.target.value })} style={{ ...inp, direction: "ltr" }} />

          <label style={lbl}>الحالة</label>
          <select value={form.status} onChange={(e) => setForm({ ...form, status: e.target.value })} style={{ ...inp }}>
            {["محتفظ", "معروض", "مباع"].map(s => <option key={s} value={s} style={{ background: "#1a1410" }}>{s}</option>)}
          </select>

          <label style={lbl}>ملاحظات</label>
          <textarea placeholder="ملاحظات..." value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} style={{ ...inp, resize: "vertical", minHeight: 70 }} />

          <button onClick={add} disabled={saving}
            style={{ width: "100%", background: saving ? "#444" : gold, color: "#0f0d0a", border: "none", borderRadius: 10, padding: 13, fontWeight: 700, cursor: saving ? "not-allowed" : "pointer", fontSize: 14 }}>
            {saving ? "جارٍ الحفظ..." : "حفظ الدومين ◈"}
          </button>
        </div>
      )}

      {domains.length === 0 && !adding && (
        <div style={{ textAlign: "center", padding: "60px 0", color: "#444" }}>
          <div style={{ fontSize: 44, marginBottom: 14 }}>◈</div>
          <div>لا توجد دومينات — أضف أول دومين</div>
        </div>
      )}

      {domains.map((d) => {
        const daysLeft = getDaysLeft(d.expiry);
        const isExpiring = daysLeft !== null && daysLeft <= 60 && daysLeft > 0;
        const isExpired = daysLeft !== null && daysLeft <= 0;
        const totalRenewed = (d.renewals || []).reduce((s, r) => s + r.cost, 0);

        return (
          <div key={d.id} style={{ background: "rgba(255,255,255,0.04)", border: `1px solid ${isExpired ? "rgba(196,124,124,0.4)" : isExpiring ? "rgba(200,169,110,0.3)" : "rgba(255,255,255,0.08)"}`, borderRadius: 14, padding: 16, marginBottom: 12 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
              <div style={{ flex: 1 }}>
                <div style={{ color: "#fff", fontWeight: 700, fontSize: 15, direction: "ltr", textAlign: "left", marginBottom: 8 }}>{d.name}</div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                  <span style={{ background: `${sc[d.status]}22`, color: sc[d.status], borderRadius: 6, padding: "2px 10px", fontSize: 11 }}>{d.status}</span>
                  {d.registrar && <span style={{ background: "rgba(255,255,255,0.05)", color: "#777", borderRadius: 6, padding: "2px 10px", fontSize: 11 }}>{d.registrar}</span>}
                  {d.asking_price > 0 && <span style={{ background: "rgba(139,196,168,0.1)", color: "#8bc4a8", borderRadius: 6, padding: "2px 10px", fontSize: 11 }}>طلب: ${d.asking_price}</span>}
                </div>
              </div>
              <button onClick={() => remove(d.id)} style={{ background: "none", border: "none", color: "#333", cursor: "pointer", fontSize: 18 }}>✕</button>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginTop: 12, background: "rgba(0,0,0,0.2)", borderRadius: 10, padding: 12 }}>
              <div><div style={{ color: "#555", fontSize: 10, marginBottom: 3 }}>📅 تاريخ الشراء</div>
                <div style={{ color: "#aaa", fontSize: 12 }}>{d.purchase_date || "—"}</div></div>
              <div><div style={{ color: "#555", fontSize: 10, marginBottom: 3 }}>⏰ ينتهي في</div>
                <div style={{ color: isExpired ? "#c47c7c" : isExpiring ? gold : "#aaa", fontSize: 12, fontWeight: isExpiring || isExpired ? 700 : 400 }}>
                  {d.expiry || "—"}{isExpired ? " ⚠️" : isExpiring ? ` (${daysLeft}y)` : ""}
                </div></div>
              <div><div style={{ color: "#555", fontSize: 10, marginBottom: 3 }}>💰 التكلفة الكلية</div>
                <div style={{ color: "#aaa", fontSize: 12 }}>${((d.cost || 0) + totalRenewed).toFixed(0)}</div></div>
              <div><div style={{ color: "#555", fontSize: 10, marginBottom: 3 }}>🔄 تجديدات</div>
                <div style={{ color: "#7c9cba", fontSize: 12 }}>${totalRenewed} ({(d.renewals || []).length}×)</div></div>
            </div>

            {d.platforms && <div style={{ color: "#555", fontSize: 12, marginTop: 8 }}>منصات: <span style={{ color: "#888" }}>{d.platforms}</span></div>}
            {d.notes && <div style={{ color: "#555", fontSize: 12, marginTop: 5, fontStyle: "italic" }}>{d.notes}</div>}

            <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
              <button onClick={() => analyze(d)} disabled={aiLoading === d.id}
                style={{ flex: 1, background: "rgba(200,169,110,0.1)", border: "1px solid rgba(200,169,110,0.2)", borderRadius: 7, padding: "7px 0", color: gold, cursor: "pointer", fontSize: 12 }}>
                {aiLoading === d.id ? "جارٍ..." : "◉ تحليل AI"}
              </button>
              <button onClick={() => setExpanded(expanded === d.id ? null : d.id)}
                style={{ flex: 1, background: "rgba(124,156,186,0.1)", border: "1px solid rgba(124,156,186,0.2)", borderRadius: 7, padding: "7px 0", color: "#7c9cba", cursor: "pointer", fontSize: 12 }}>
                🔄 التجديدات
              </button>
            </div>

            {aiResult[d.id] && <div style={{ background: "rgba(200,169,110,0.05)", borderRadius: 8, padding: 12, marginTop: 10, color: "#ccc", fontSize: 13, lineHeight: 1.8 }}>{aiResult[d.id]}</div>}
            {expanded === d.id && <RenewalLog domain={d} onRefresh={onRefresh} />}
          </div>
        );
      })}
    </div>
  );
}
